import React, {useState} from "react";

/** Editor form primitives: a labelled field, a section card, and a chip picker (amenities). */

/** `group` for a control that isn't a single input (pickers, uploaders): a <label> would forward clicks into it. */
export const Field = ({label, required, hint, error, children, wide, group}) => {
    const Tag = group ? "div" : "label";
    return (
        <Tag className={`brk-field${wide ? " brk-field--wide" : ""}${error ? " brk-field--error" : ""}`}
             {...(group ? {role: "group", "aria-label": typeof label === "string" ? label : undefined} : {})}>
            <span className="brk-field__label">{label}{required && <span className="brk-req" aria-hidden="true"> *</span>}</span>
            {children}
            {hint && !error && <span className="brk-hint">{hint}</span>}
            {error && <span className="brk-field__error">{error}</span>}
        </Tag>
    );
};

export const Section = ({title, subtitle, children, actions}) => (
    <section className="brk-section">
        <div className="brk-section__head">
            <div>
                <h2 className="brk-section__title">{title}</h2>
                {subtitle && <p className="brk-section__subtitle">{subtitle}</p>}
            </div>
            {actions}
        </div>
        <div className="brk-grid">{children}</div>
    </section>
);

export const ChipPicker = ({options, value = [], onChange, addLabel = "Add another"}) => {
    const [custom, setCustom] = useState("");
    const all = [...options, ...value.filter((v) => !options.includes(v))];
    const toggle = (opt) => onChange(value.includes(opt) ? value.filter((v) => v !== opt) : [...value, opt]);
    const addCustom = () => {
        const v = custom.trim();
        if (v && !value.includes(v)) onChange([...value, v]);
        setCustom("");
    };
    return (
        <div className="brk-chips">
            {all.map((opt) => (
                <button key={opt} type="button" aria-pressed={value.includes(opt)}
                        className={`brk-chip${value.includes(opt) ? " brk-chip--on" : ""}`} onClick={() => toggle(opt)}>
                    {value.includes(opt) ? "✓ " : ""}{opt}
                </button>
            ))}
            <span className="brk-chips__add">
                <input className="brk-input brk-input--sm" placeholder={addLabel} value={custom}
                       onChange={(e) => setCustom(e.target.value)}
                       onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addCustom(); } }}/>
                <button type="button" className="brk-btn brk-btn--ghost brk-btn--sm" onClick={addCustom}>Add</button>
            </span>
        </div>
    );
};

export const numberOrNull = (v) => (v === "" || v === null || v === undefined ? null : Number(v));

export const formatPrice = (price) => {
    const n = Number(price);
    if (!n) return "";
    if (n >= 1e7) return `₹${(n / 1e7).toFixed(2).replace(/\.00$/, "")} Cr`;
    if (n >= 1e5) return `₹${(n / 1e5).toFixed(2).replace(/\.00$/, "")} L`;
    return `₹${n.toLocaleString("en-IN")}`;
};
